import { CtrlIconConfig } from '@co-3/ctrl-ui/icons';

export const icons: CtrlIconConfig[] = [
    {
        name: 'damage',
        url: '/assets/icons/icon-service/icon_damage.svg',
    },
    {
        name: 'damage_big',
        url: '/assets/icons/icon-service/icon_damage_big.svg',
    },
    {
        name: 'musician',
        url: '/assets/icons/icon-service/icon_musik_schueler.svg',
    },
    {
        name: 'person',
        url: '/assets/icons/icon-service/icon_person.svg',
    },
    {
        name: 'electronics',
        url: '/assets/icons/icon-service/icon_elektronik.svg',
    },
    {
        name: 'laptop_smartphone',
        url: '/assets/icons/icon-service/icon_office.svg',
    },
    {
        name: 'backpacker',
        url: '/assets/icons/icon-service/icon_backpacker.svg',
    },
    {
        name: 'tablet',
        url: '/assets/icons/icon-service/icon_tablet.svg',
    },
    {
        name: 'tablet_reader',
        url: '/assets/icons/icon-service/icon_tablet_reader.svg',
    },
    {
        name: 'musician_pro',
        url: '/assets/icons/icon-service/icon_berufsmusiker.svg',
    },
    {
        name: 'music_school',
        url: '/assets/icons/icon-service/icon_musik_schulen.svg',
    },
    {
        name: 'incident',
        url: '/assets/icons/icon-service/icon_schueler_unfall.svg',
    },
    {
        name: 'save',
        url: '/assets/icons/icon-service/icon_save.svg',
    },
    {
        name: 'tuition',
        url: '/assets/icons/icon-service/icon_nachhilfe.svg',
    },
    {
        name: 'bike-1',
        url: '/assets/icons/icon-service/icon_bike.svg',
    },
    {
        name: 'bike-2',
        url: '/assets/icons/icon-service/icon_fahrrad.svg',
    },
    {
        name: 'smartphone',
        url: '/assets/icons/icon-service/icon_handy.svg',
    },
    {
        name: 'smartphone-2',
        url: '/assets/icons/icon-service/icon_smartphone_2.svg',
    },
    {
        name: 'camera',
        url: '/assets/icons/icon-service/icon_camera.svg',
    },
    {
        name: 'lens',
        url: '/assets/icons/icon-service/icon_lens.svg',
    },
    {
        name: 'notebook',
        url: '/assets/icons/icon-service/icon_notebook.svg',
    },
    {
        name: 'beamer',
        url: '/assets/icons/icon-service/icon_beamer.svg',
    },
    {
        name: 'appliance',
        url: '/assets/icons/icon-service/icon_home_appliance.svg',
    },
    {
        name: 'tv',
        url: '/assets/icons/icon-service/icon_tv.svg',
    },
    {
        name: 'pc-monitor',
        url: '/assets/icons/icon-service/icon_pc_monitor.svg',
    },
    {
        name: 'console',
        url: '/assets/icons/icon-service/icon_console.svg',
    },
    {
        name: 'vr-glasses',
        url: '/assets/icons/icon-service/icon_vr_glasses.svg',
    },
    {
        name: 'headphones',
        url: '/assets/icons/icon-service/icon_headphones.svg',
    },
    {
        name: 'smartwatch',
        url: '/assets/icons/icon-service/icon_smartwatch.svg',
    },
    {
        name: 'chevron_right',
        url: '/assets/icons/icon-service/icon_chevron_right.svg',
    },
    {
        name: 'chevron_left',
        url: '/assets/icons/icon-service/icon_chevron_left.svg',
    },
    {
        name: 'insurance_fallback',
        url: '/assets/icons/icon-service/icon_insurance_fallback.svg',
    },
    {
        name: 'user_address',
        url: '/assets/icons/icon-service/icon_user_address.svg',
    },
    {
        name: 'warning',
        url: '/assets/icons/icon-service/icon_warning.svg',
    },
    {
        name: 'group',
        url: '/assets/icons/icon-service/icon_group.svg',
    },
    {
        name: 'instrument',
        url: '/assets/icons/icon-service/icon_instrument.svg',
    },
    {
        name: 'credit_card',
        url: '/assets/icons/icon-service/icon_credit_card.svg',
    },
    {
        name: 'edit',
        url: '/assets/icons/icon-service/icon_edit.svg',
    },
    {
        name: 'schedule',
        url: '/assets/icons/icon-service/icon_schedule.svg',
    },
    {
        name: 'paper_plane',
        url: '/assets/icons/icon-service/icon_paper_plane.svg',
    },
    {
        name: 'pen',
        url: '/assets/icons/icon-service/icon_pen.svg',
    },
    {
        name: 'close',
        url: '/assets/icons/icon-service/icon_close.svg',
    },
    {
        name: 'account',
        url: '/assets/icons/icon-service/icon_account.svg',
    },
    {
        name: 'new_contract',
        url: '/assets/icons/icon-service/icon_new_contract.svg',
    },
    {
        name: 'kebab',
        url: '/assets/icons/icon-service/icon_kebab.svg',
    },
    {
        name: 'trash',
        url: '/assets/icons/icon-service/icon_trash.svg',
    },
    {
        name: 'login',
        url: '/assets/icons/icon-service/icon_login.svg',
    },
    {
        name: 'adress_book',
        url: '/assets/icons/icon-service/icon_adress_book.svg',
    },
    {
        name: 'invoice',
        url: '/assets/icons/icon-service/icon_invoice.svg',
    },
    {
        name: 'folder_camera',
        url: '/assets/icons/icon-service/icon_folder_camera.svg',
    },
    {
        name: 'add',
        url: '/assets/icons/icon-service/icon_add.svg',
    },
    {
        name: 'pdf',
        url: '/assets/icons/icon-service/icon_pdf.svg',
    },
    {
        name: 'file',
        url: '/assets/icons/icon-service/icon_file.svg',
    },
    {
        name: 'file_pdf',
        url: '/assets/icons/icon-service/icon_file_pdf.svg',
    },
    {
        name: 'circle_check',
        url: '/assets/icons/icon-service/icon_check_in_circle.svg',
    },
    {
        name: 'circle',
        url: 'assets/icons/icon-service/icon_circle.svg',
    },
    {
        name: 'credit_card_big',
        url: '/assets/icons/icon-service/icon_credit_card_big.svg',
    },
    {
        name: 'clip',
        url: '/assets/icons/icon-service/icon_clip.svg',
    },
    {
        name: 'home',
        url: '/assets/icons/icon-service/icon_home.svg',
    },
    {
        name: 'logout',
        url: '/assets/icons/icon-service/icon_logout.svg',
    },
    {
        name: 'arrow_right',
        url: '/assets/icons/icon-service/icon_arrow_right.svg',
    },
    {
        name: 'download',
        url: '/assets/icons/icon-service/icon_download.svg',
    },
    {
        name: 'deactivate_account',
        url: '/assets/icons/icon-service/icon_deactivate_account.svg',
    },
];
